import { BemHelper } from "@/utils/BemHelper";
import React from "react";
import { Theme, ThemeFontVariant } from "../types";
import classNames from "classnames";
import { THEME_FONT_VARIANTS } from "../constants";

export type CtInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  error?: string;
  invalid?: boolean;
  theme?: Theme;
  fontVariant?: ThemeFontVariant;
};

const bem = new BemHelper("ct-input");

function CtInput({ label, error, theme, fontVariant, invalid, ...rest }: CtInputProps) {
  return (
    <div
      className={classNames(
        bem.block(),
        bem.modifier(fontVariant || THEME_FONT_VARIANTS.FONT_VARIANT_1),
        theme && bem.modifier(theme),
        (error || invalid) && bem.modifier("error"),
      )}
    >
      {label && <label className={bem.element("label")}>{label}</label>}
      <input className={bem.element("input")} {...rest} />
      {error && <div className={bem.element("error")}>{error}</div>}
    </div>
  );
}

CtInput.defaultProps = {
  theme: undefined,
  error: undefined,
  invalid: false,
  fontVariant: THEME_FONT_VARIANTS.FONT_VARIANT_1,
};

export default CtInput;
